import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-chapitre',
  templateUrl: './chapitre.component.html',
  styleUrl: './chapitre.component.scss'
})
export class ChapitreComponent implements OnInit {

  exercice: number = new Date().getFullYear();

  chapitres: any[] = [];
  paginatedProjets: any[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  isLoading = false;

  item: any = {};

  @ViewChild('chapitreModal') chapitreModal: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    const stored = this.localStorage.getExerciceToUserToSuivieEvaluation();
    if (stored) {
      this.exercice = Number(stored) || new Date().getFullYear();
    }
    this.loadData();
  }

  loadData(): void {
    this.isLoading = false;
    this.ngxService.start();
    this.paramService.getBordereauChapitres({ annee: this.exercice }).subscribe(
      (response: any) => {
        this.chapitres = response.data || [];
        this.totalRecords = this.chapitres.length;
        this.updatePaginated();
        this.isLoading = true;
        this.ngxService.stop();
      },
      (error: any) => {
        this.isLoading = true;
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors du chargement des chapitres'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    this.paginatedProjets = this.chapitres.slice(this.first, this.first + this.rows);
  }

  openModal(item?: any) {
    this.item = item ? { ...item } : { annee: this.exercice };
    this.modalService.open(this.chapitreModal, { centered: true, backdrop: 'static', size: 'lg' });
  }

  save() {
    if (!this.item.code || !this.item.libelle) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Veuillez renseigner le code et le libellé'
      });
      return;
    }
    this.ngxService.start();
    const reference = this.item.reference;
    this.paramService.saveBordereauChapitre(this.item, reference).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue'
        });
      }
    );
  }

  confirmSuppression(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer le chapitre ' + item.libelle + ' ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramService.deleteBordereauChapitre(item.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
            this.loadData();
          },
          (error: any) => {
            this.ngxService.stop();
            this.messageService.add({
              severity: 'error',
              summary: Constant.suiviTitle,
              detail: error?.error?.message || 'Une erreur est survenue'
            });
          }
        );
      }
    });
  }
}
